import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable, Subject, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NavService {
  private resourcePath1: string = 'dbov2/nav-branch';
  private resourcePath2: string = 'dbov2/nav-gl-account-history-report';
  private resourcePath3: string = 'dbov2/nav-mapping';

  private _dataSource$ = new Subject<boolean>();

  constructor(
    private httpClient: HttpClient) {
  }

  getFilterButtonEvent(): Observable<boolean>{
    return this._dataSource$.asObservable();
  }
  
  openFilterButton(){
    this._dataSource$.next(true);
  }

  errorHandler(error: HttpErrorResponse) {
    return throwError(error.message || 'server Error');
  }

  public getNavBranches(): Observable<any> {
    return this.httpClient
      .get<any>(`${this.resourcePath1}`)
      .pipe(catchError(this.errorHandler));
  }

  public getNavReport(dataSourceId: number, navBranchId: number): Observable<any> {
    let httpParams = new HttpParams({
      fromObject: {
        SourceId: dataSourceId,
        NavBranchId: navBranchId
      }
    });
    return this.httpClient
      .get<any>(`${this.resourcePath2}`, {params: httpParams})
      .pipe(catchError(this.errorHandler));
  }

  public getNavGlMapping(navBranchId: number): Observable<any> {
    let httpParams = new HttpParams({fromObject: {NavBranchId: navBranchId}});
    return this.httpClient
      .get<any>(`${this.resourcePath3}`, {params: httpParams})
      .pipe(catchError(this.errorHandler));
  }

  uploadNavReportFiles(formData: FormData): Observable<boolean> {
    const headers = new HttpHeaders({'Content-Type': 'multipart/form-data'});
    return this.httpClient.post<boolean>(`${this.resourcePath2}`, formData, {headers});
  }

  uploadNavMappingFile(formData: FormData): Observable<boolean> {
    const headers = new HttpHeaders({'Content-Type': 'multipart/form-data'});
    return this.httpClient.post<boolean>(`${this.resourcePath3}`, formData, {headers});
  }
}
